export default {"src":"/_next/static/media/china.f1e5286d.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};